import { z } from "zod";

import { PeriodLayout, previewPeriodCount } from "./periodLayout";

const weight = z.number().min(0).max(1);
const periodWeights = z.discriminatedUnion("kind", [
  z.object({
    kind: z.literal("relative"),
    first_period_weight: weight,
    subsequent_period_weight: weight,
  }),
  z.object({
    kind: z.literal("decaying"),
    deployable_decay_factor: weight,
    non_deployable_decay_factor: weight,
  }),
]);

export const illustratePeriodWeights = ({
  parameters,
  periodLayout,
}: {
  parameters: unknown;
  periodLayout: PeriodLayout;
}) => {
  const parsed = periodWeights.safeParse(parameters);
  if (!parsed.success) return [];
  const weights = parsed.data;
  const deployablePeriods = previewPeriodCount(periodLayout.deployable);
  return Array.from(
    { length: deployablePeriods + previewPeriodCount(periodLayout.forecast) },
    (_, index) => {
      const deployable = index < deployablePeriods;
      return {
        period: index + 1,
        deployable,
        weight:
          weights.kind === "relative"
            ? index === 0
              ? weights.first_period_weight
              : weights.subsequent_period_weight
            : weights.deployable_decay_factor **
                Math.min(index, deployablePeriods - 1) *
              weights.non_deployable_decay_factor **
                Math.max(0, index - deployablePeriods + 1),
      };
    }
  );
};
